/** String containing environment value, can be either development, production or localhost */
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'localhost'

/** ENV variable ENVIRONMENT value, can be either development, production or localhost  */
export enum EnvironmentValue {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  LOCALHOST = 'localhost'
}
